/* MAISON AURÉLIA — Custom JavaScript */
function maSplashInit() {
  const splash = document.getElementById('ma-splash');
  if (!splash) return;
  if (sessionStorage.getItem('ma-splash-shown')) { splash.remove(); return; }
  setTimeout(() => splash.classList.add('ma-splash--show'), 80);
  setTimeout(() => splash.classList.add('ma-splash--up'), 2650);
  setTimeout(() => { splash.remove(); sessionStorage.setItem('ma-splash-shown', '1'); }, 3750);
}

const maRevealObserver = new IntersectionObserver((entries) => {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      entry.target.classList.add('in-view');
      maRevealObserver.unobserve(entry.target);
    }
  });
}, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });

function maRevealInit() {
  document.querySelectorAll('.ma-reveal').forEach(el => maRevealObserver.observe(el));
}

function maAutoReveal() {
  const delays = ['','reveal-d1','reveal-d2','reveal-d3','reveal-d4','reveal-d5'];
  function addReveal(el, delayClass) {
    if (el.classList.contains('ma-reveal')) return;
    const rect = el.getBoundingClientRect();
    const alreadyVisible = rect.top < window.innerHeight && rect.bottom > 0;
    el.classList.add('ma-reveal');
    if (delayClass) el.classList.add(delayClass);
    if (alreadyVisible) { el.classList.add('in-view'); }
    else { maRevealObserver.observe(el); }
  }
  document.querySelectorAll('.product-card').forEach((el, i) => addReveal(el, delays[i % 3]));
  document.querySelectorAll('.section-header, .collection-title, h1, h2').forEach(el => { if (!el.closest('#ma-splash')) addReveal(el, ''); });
  document.querySelectorAll('.product-info__title, .product-info__price, .variant-picker, .buy-buttons').forEach((el, i) => addReveal(el, delays[Math.min(i, 4)]));
}

function maParallaxInit() {
  window.addEventListener('scroll', function() {
    document.querySelectorAll('.ma-parallax-hero').forEach(img => {
      img.style.transform = 'scale(1.06) translateY(' + (window.scrollY * 0.14) + 'px)';
    });
  }, { passive: true });
}

let _lbImages = [];
let _lbIndex  = 0;
function maLightboxOpen(images, startIndex) {
  _lbImages = images; _lbIndex = startIndex || 0;
  maLightboxRender();
  document.getElementById('ma-lightbox').classList.add('open');
  document.addEventListener('keydown', maLightboxKey);
}
function maLightboxClose(e) {
  if (e && e.target !== document.getElementById('ma-lightbox') && !e.target.classList.contains('ma-lightbox__close')) return;
  document.getElementById('ma-lightbox').classList.remove('open');
  document.removeEventListener('keydown', maLightboxKey);
}
function maLightboxNav(dir) {
  _lbIndex = (_lbIndex + dir + _lbImages.length) % _lbImages.length;
  maLightboxRender();
}
function maLightboxRender() {
  document.getElementById('ma-lightbox-img').src = _lbImages[_lbIndex];
  const counter = document.getElementById('ma-lightbox-counter');
  if (counter) counter.textContent = (_lbIndex + 1) + ' / ' + _lbImages.length;
}
function maLightboxKey(e) {
  if (e.key === 'ArrowRight') maLightboxNav(1);
  else if (e.key === 'ArrowLeft') maLightboxNav(-1);
  else if (e.key === 'Escape') { document.getElementById('ma-lightbox').classList.remove('open'); document.removeEventListener('keydown', maLightboxKey); }
}
function maLightboxWireProduct() {
  const tryWire = () => {
    const mediaItems = document.querySelectorAll('.product-media-gallery [data-media-type="image"] img, .product__media img, product-media img, [data-media-id] img');
    if (!mediaItems.length) return;
    const getFullSrc = (img) => {
      if (img.srcset) { const parts = img.srcset.split(',').map(s => s.trim().split(' ')); return parts[parts.length - 1][0]; }
      return img.src;
    };
    mediaItems.forEach((img, i) => {
      img.style.cursor = 'zoom-in';
      img.addEventListener('click', () => {
        const srcs = Array.from(mediaItems).map(getFullSrc);
        maLightboxOpen(srcs, i);
      });
    });
  };
  tryWire();
  setTimeout(tryWire, 800);
  setTimeout(tryWire, 2000);
}

function maAccordionInit() {
  document.querySelectorAll('.ma-accord-hdr').forEach(hdr => {
    hdr.addEventListener('click', () => {
      const item = hdr.parentElement;
      const isOpen = item.classList.contains('open');
      document.querySelectorAll('.ma-accord-item.open').forEach(i => i.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });
}

function maMarqueeInit() {
  document.querySelectorAll('.ma-marquee').forEach(el => {
    el.addEventListener('mouseenter', () => { el.querySelectorAll('.ma-marquee__track').forEach(t => t.style.animationPlayState = 'paused'); });
    el.addEventListener('mouseleave', () => { el.querySelectorAll('.ma-marquee__track').forEach(t => t.style.animationPlayState = 'running'); });
  });
}

(function() {
  let _touchStartX = 0;
  document.addEventListener('touchstart', e => {
    if (!document.getElementById('ma-lightbox')?.classList.contains('open')) return;
    _touchStartX = e.touches[0].clientX;
  }, { passive: true });
  document.addEventListener('touchend', e => {
    if (!document.getElementById('ma-lightbox')?.classList.contains('open')) return;
    const diff = _touchStartX - e.changedTouches[0].clientX;
    if (Math.abs(diff) > 50) maLightboxNav(diff > 0 ? 1 : -1);
  }, { passive: true });
})();

/* ══════════════════════════════════════════
   DRAWER SEARCH INJECTION (Maison Aurélia)
   Adds "SEARCH" with magnifying-glass icon as first item
   in the mobile drawer menu, removes need for header search.
══════════════════════════════════════════ */
function maInjectDrawerSearch() {
  if (window.innerWidth > 749) return;

  const selectors = [
    'menu-drawer .menu-drawer__content',
    '.menu-drawer__menu',
    '#Details-menu-drawer-container .menu-drawer',
    '#Details-menu-drawer-container',
    '.header-drawer__menu',
    '.menu-drawer',
    'header-menu .menu-drawer-component',
    '.drawer-menu',
    '.mobile-menu'
  ];

  let drawer = null;
  for (const sel of selectors) {
    const el = document.querySelector(sel);
    if (el) { drawer = el; break; }
  }
  if (!drawer) return;
  if (drawer.querySelector('.ma-drawer-search')) return;

  const btn = document.createElement('button');
  btn.className = 'ma-drawer-search';
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Open search');
  btn.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="none" aria-hidden="true"><circle cx="9" cy="9" r="4.75" stroke="currentColor" stroke-width="1.2"/><path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.2" d="m12.5 12.5 3.25 3.25"/></svg><span>Search</span>';
  btn.addEventListener('click', (e) => {
    e.preventDefault();
    e.stopPropagation();
    // Close drawer
    const drawerOpen = document.querySelector('details[open] > summary.header__icon--menu, details[open] menu-drawer, [aria-expanded="true"].header__icon--menu');
    if (drawerOpen) {
      const details = drawerOpen.closest('details');
      if (details) details.removeAttribute('open');
    }
    document.querySelectorAll('details[open]').forEach(d => {
      if (d.contains(document.querySelector('.menu-drawer')) || d.id === 'Details-menu-drawer-container') {
        d.removeAttribute('open');
      }
    });
    // Open search
    setTimeout(() => {
      const trigger = document.querySelector('search-button button, [aria-haspopup="dialog"][aria-label="Search"]');
      if (trigger) { trigger.click(); return; }
      const modal = document.querySelector('#search-modal');
      if (modal) {
        if (typeof modal.showDialog === 'function') modal.showDialog();
        else if (typeof modal.showModal === 'function') modal.showModal();
      }
    }, 80);
  });
  drawer.insertBefore(btn, drawer.firstChild);
}

// Run on load and watch for drawer DOM changes
document.addEventListener('DOMContentLoaded', () => {
  maSplashInit();
  maRevealInit();
  maAutoReveal();
  maParallaxInit();
  maMarqueeInit();
  maLightboxWireProduct();
  maAccordionInit();
  maInjectDrawerSearch();
});

// Re-run on Shopify section reload (editor)
document.addEventListener('shopify:section:load', () => {
  maAutoReveal();
  maLightboxWireProduct();
  maAccordionInit();
  maInjectDrawerSearch();
});

// Periodic retry in case drawer is lazy-rendered
let _maDrawerTries = 0;
const _maDrawerInterval = setInterval(() => {
  _maDrawerTries++;
  maInjectDrawerSearch();
  if (_maDrawerTries > 12) clearInterval(_maDrawerInterval);
}, 800);

// Re-inject when drawer opens (in case it's recreated)
document.addEventListener('click', (e) => {
  if (e.target.closest('.header__icon--menu, button[aria-controls*="menu"], [aria-haspopup="dialog"][aria-label*="menu" i]')) {
    setTimeout(maInjectDrawerSearch, 60);
    setTimeout(maInjectDrawerSearch, 300);
  }
}, true);
